import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import help from "../assets/images/help.png";
import { helpSupport } from '../services/ProfileApi';
import { showToast } from '../config/Alert';
import LoadingSpinner from './LoadingSpinner';

const HelpSupport = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [formData, setFormData] = useState({
    message: '',
    user_id: user?.id || ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.message.trim()) {
      showToast("Please enter a message", "error");
      return;
    }

    try {
      setLoading(true);
      await helpSupport(formData);
      showToast("Your request has been submitted successfully", "success");
      setFormData({ message: '', user_id: user?.id || '' });
    } catch (error) {
      showToast(error.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>
        <div className='AccountInnerMain mb-3'>
          <h6 className=''>
            <img src={help} width={20} alt="help" />
            <span className='ps-1'> Help & Support</span>
          </h6>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="helpSupport">
            <Form.Control as="textarea" name='message' rows={5} placeholder='I need help with ...' className='border-2 rounded-3'
              value={formData.message} onChange={handleChange} />
          </Form.Group>
          <Form.Group className='text-center'>
            <Button variant="info" type="submit" className='rounded-5 px-5 text-white border-2 border-secondary'>
              Submit
            </Button>
          </Form.Group>
        </Form>
        <div className='border-2 my-4 border-bottom'></div>
        <div className='text-center'>
          <h6 className='mb-3 fs-12'>Need assistance? We're just a call away!</h6>
          <Button variant="danger" type="submit" className='rounded-5 px-5 text-white border-2 border-secondary'>
            Call Us
          </Button>
        </div>
        <div className='border-2 my-4 border-bottom'></div>
        <h6 className='mb-3 text-center fs-12'>thepiedpiper1001@gmail.com</h6>
      </Container>
    </div>
  );
}

export default HelpSupport;
